import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@nutrix/data-access-auth';
import { inject } from '@angular/core';

export const chatGuard: CanActivateFn = () => {
  const user = inject(AuthService).loadCurrentUser();
  if (user?.featureAccess?.chat.read === false) {
    return false;
  }
  return true;
};

export const teleconsultationGuard: CanActivateFn = () => {
  const user = inject(AuthService).loadCurrentUser();
  if (user?.featureAccess?.teleconsultation.read === false && user?.featureAccess?.agendaScheduling.read === false) {
    return false;
  }
  return true;
};

export const patientLogsGuard: CanActivateFn = () => {
  const user = inject(AuthService).loadCurrentUser();
  if (user?.featureAccess?.logs.read === false) {
    return false;
  }
  return true;
};

export const patientLabTestGuard: CanActivateFn = () => {
  const user = inject(AuthService).loadCurrentUser();
  if (user?.featureAccess?.labTests.read === false) {
    return false;
  }
  return true;
};

export const patientStatisticsGuard: CanActivateFn = () => {
  const user = inject(AuthService).loadCurrentUser();
  if (user?.featureAccess?.statistics.read === false) {
    return false;
  }
  return true;
};

export const patientPrescriptionsGuard: CanActivateFn = () => {
  const user = inject(AuthService).loadCurrentUser();
  if (user?.featureAccess?.prescriptions.read === false) {
    return false;
  }
  return true;
};

export const patientFoodsGuard: CanActivateFn = () => {
  const user = inject(AuthService).loadCurrentUser();
  if (user?.featureAccess?.food.read === false) {
    return false;
  }
  return true;
};

export const caseManagerGuard: CanActivateFn = () => {
  const user = inject(AuthService).loadCurrentUser();
  const router = inject(Router);
  if (
    user?.featureAccess?.caseManager?.read ||
    user?.featureAccess?.treatmentPlan?.read ||
    user?.featureAccess?.nutritionalPlan?.read
  ) {
    return true;
  }
  if (user?.featureAccess?.teleconsultation?.read) return router.parseUrl('/home/agenda');
  if (user?.featureAccess?.journey?.read) return router.parseUrl('/home/patients');
  if (user?.featureAccess?.chat?.read) return router.parseUrl('/home/chats');
  if (user?.featureAccess?.hR?.read) return router.parseUrl('/home/hr');
  if (user?.featureAccess?.laboratory?.read) return router.parseUrl('/home/laboratory');
  return router.parseUrl('/home/profile');
};

export const hrGuard: CanActivateFn = () => {
  const user = inject(AuthService).loadCurrentUser();
  if (user?.featureAccess.hR.read) {
    return true;
  }
  return false;
};

export const laboratoryGuard: CanActivateFn = () => {
  const user = inject(AuthService).loadCurrentUser();
  if (user?.featureAccess.laboratory.read) {
    return true;
  }
  return false;
};

export const patientsGuard: CanActivateFn = () => {
  const user = inject(AuthService).loadCurrentUser();
  if (user?.featureAccess.journey.read) {
    return true;
  }
  return false;
};

/**
 * Support chat is available to every authenticated professional/support user.
 * Patients never reach the dashboard shell, but we block them here explicitly too.
 */
export const supportChatGuard: CanActivateFn = () => {
  const user = inject(AuthService).loadCurrentUser();
  if (!user || user.patient) {
    return false;
  }
  return true;
};

export const homeRedirectGuard: CanActivateFn = () => {
  const router = inject(Router);
  const user = inject(AuthService).loadCurrentUser();

  if (
    user?.featureAccess?.caseManager?.read ||
    user?.featureAccess?.treatmentPlan?.read ||
    user?.featureAccess?.nutritionalPlan?.read
  ) {
    return router.parseUrl('/home/case-manager');
  }

  if (user?.featureAccess?.teleconsultation?.read) {
    return router.parseUrl('/home/agenda');
  }

  if (user?.featureAccess?.journey?.read) {
    return router.parseUrl('/home/patients');
  }

  if (user?.featureAccess?.chat?.read) {
    return router.parseUrl('/home/chats');
  }

  if (user?.featureAccess?.hR?.read) {
    return router.parseUrl('/home/hr');
  }

  if (user?.featureAccess?.laboratory?.read) {
    return router.parseUrl('/home/laboratory');
  }

  return router.parseUrl('/home/profile');
};
